<template>
  <el-select
    v-model="status"
    style="width: 100px;"
    placeholder="请选择出库单状态"
    @change="onChange">
    <el-option
      label="全部"
      :value="null">
    </el-option>
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { OutStatusName } from '../../utils/index'
export default {
  name: 'StatusSelect',
  props: {
    callback: {
      type: Function
    },
    type: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: OutStatusName
    }
  },
  computed: {
    status: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
